interface ISpecDefinition<TSpecValue extends string> {
  scopes: string[];
  owner: string;
  controlGroup: TSpecValue;
  variants: TSpecValue[];
  onlyForLoggedInUsers: boolean;
  persistent?: boolean;
  allowedForBots?: boolean;
}

type ITrueFalseSpecDefinition = ISpecDefinition<'true' | 'false'>;

interface ISpecDefinitionMap<TSpecValue extends string = string> {
  [key: string]: ISpecDefinition<TSpecValue>;
}

const SPECS_SCOPE = 'vmaf';
const FINAL_PAGE_VERSION_SPEC = 'specs.vmaf.FinalPageVersion';
const SHORT_FLOW_SPEC = 'specs.vmaf.ShortFlow';
const FULL_STORY_SPEC = 'specs.vmaf.FullStory';

const petriSpecs: ISpecDefinitionMap = {
  [FINAL_PAGE_VERSION_SPEC]: {
    scopes: [SPECS_SCOPE],
    owner: 'bohdanl@wix.com',
    controlGroup: 'v2',
    variants: ['v1'],
    onlyForLoggedInUsers: false,
  } as ISpecDefinition<'v1' | 'v2'>,
  [SHORT_FLOW_SPEC]: {
    scopes: [SPECS_SCOPE],
    owner: 'bohdanl@wix.com',
    controlGroup: 'false',
    variants: ['true'],
    onlyForLoggedInUsers: false,
  } as ITrueFalseSpecDefinition,
  [FULL_STORY_SPEC]: {
    scopes: [SPECS_SCOPE],
    owner: 'bohdanl@wix.com',
    controlGroup: 'false',
    variants: ['true'],
    onlyForLoggedInUsers: false,
  } as ITrueFalseSpecDefinition,
};

export {
  ISpecDefinitionMap,
  SPECS_SCOPE,
  FINAL_PAGE_VERSION_SPEC,
  SHORT_FLOW_SPEC,
  FULL_STORY_SPEC,
};

export default petriSpecs;
